import S from './SingleDam.module.css'
import F from './AllFarmsAdmin.module.css'
import G from './ListDam.module.css'
import D from '../images/cow.svg'
import Note from '../images/note.svg'

import DeleteIcon from '@mui/icons-material/Delete';
import RateReviewIcon from '@mui/icons-material/RateReview';
import InfoIcon from '@mui/icons-material/Info';
import ReportIcon from '@mui/icons-material/Report';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import {  ArrowBack, ArrowForward, Close, CycloneOutlined, DateRange, DateRangeRounded, DeleteForever, Edit, EventAvailable, Female, FormatListBulleted, HomeWork, HorizontalSplitSharp, NoteAdd, RateReview, Search, Sell, SensorDoor, Sensors, SplitscreenOutlined, TitleOutlined, TitleRounded } from '@mui/icons-material'
import NoSegmentLabels from '../Components/MyGauge'
import StChart from '../Components/StockChart'
import { useGlobalContext } from '../Components/Context'
import EditModalDam from '../Components/EditModalDam';
import { useEffect, useRef, useState } from 'react'
import HistoryIcon from '@mui/icons-material/History';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import {  Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loginSuccessC } from '../redux/slices/singleCattleSlice'
import DeleteCattle from '../Components/DeleteCattle'
import StChart2 from '../Components/StockChart2';
import AddComment from '../Components/AddCattleComment';
import { addComments } from '../redux/slices/commentsSlice';
import EditComment from '../Components/editCattleComment';
import apiService from '../api/ApiService';
import DeleteComm from '../Components/deleteComment';
import ChangePen from '../Components/changePenMOdal';
import CommentList from '../Components/cardThemes/CommentList';
import ChangeStatus from '../Components/ChangeCattleStatusModal';
import ChangeStatusCycle from '../Components/ChangeCattleCycleModal';
import { Box, Pagination, Tab } from '@mui/material';
import { paginateCount } from '../api/helper';
import { Col, Container } from 'react-bootstrap';
import EmptyReturn from '../Components/EmptyReturn'
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import CommentsListComp from './CommentsPageComp'
import useList from '../Components/CustomHooks/useList'
import { addCattleId, addCattleListComment } from '../redux/slices/listDamSlice'
import { ToTempPen, loginSuccessP } from '../redux/slices/pensSlice'
const moment=require('moment-jalaali');

const CattleLIFilter=()=>{
  const {openModallComment,isModalCommentOpen}=useGlobalContext()
  const dispatch=useDispatch()
  const {cattleListAddComment,cattleId}=useSelector(state=>state.list)
  const {
    page,handlePage,data,total,q,setQ
  } =useList(null)
  const handleSelect = (item) => {
    if (!cattleListAddComment.includes(item)) {
      dispatch(addCattleListComment([...cattleListAddComment, item]));
    } 
   
  };
  const handleDelete=(item)=>{
    if (cattleListAddComment.includes(item)) {
      const fi=cattleListAddComment.filter(i=>{
        return i.id!=item.id
      })
      dispatch(addCattleListComment(fi));
    } 
  }
  return <div style={{width:'100%'}}>
    <div style={{display:'flex',justifyContent:'space-between'}}><span><Pagination  defaultPage={page} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  siblingCount={0} boundaryCount={0}/></span>    <div className='inputContainerSS4'>
            <input autoComplete="off" type="number"  className='inputSS4' value={q} onChange={(e)=>{
                setQ(e.target.value)
            }} placeholder="a" />
            <label for="" className={'labelSS d-flex justify-content-center align-items-center'} ><Search fontSize='small'/> جستجو دام </label>
            {q&&<span className='emptyinp' onClick={()=>setQ('')}><Close fontSize='small'/></span>}
        </div></div>
    <div className='conCattlwFilt d-flex justify-content-between align-items-center' style={{width:'100%',height:'85px',gap:'7px'}}>
    {/* <button disabled={page<=1}  className='btnnnn'onClick={()=>{setPage(page-1)} }><ArrowBack/></button> */}
    {data?.length?data.map((item,index)=>{
      return <div className={`itemCattleFilter ${item.id===cattleId?'active':''}`} key={index}>
        <div className='d-flex' style={{gap:'7px'}}>
          <div className='d-flex align-items-center' style={{gap:'7px'}}>  <Sell color='success' fontSize='small'/>  {item?.sensor?.necklaceNumber?item?.sensor?.necklaceNumber:'〰'}</div>
          <div className='d-flex align-items-center' style={{gap:'7px'}}><Sell color='success' fontSize='small'/> {item?.bodyNumber?item?.bodyNumber:'---'}</div>
          <div className='d-flex align-items-center' style={{gap:'7px'}}><Sell color='success' fontSize='small'/>  {item?.earTagNumber?item?.earTagNumber:'---'}</div>
        </div>
        <div className='btnConFilt'>
          <div className='filterBbtn' onClick={()=>{
            dispatch(addCattleId(item.id))
          }}>مشاهده یادداشت</div>
          <div className={`filterBbtnn ${cattleListAddComment.includes(item)?'active':''}`} onClick={()=>{handleSelect(item)}}>ایجاد یادداشت</div>
        </div>
      </div>
    }):<EmptyReturn w='100px' h='100px'/>}
    {/* <button disabled={total==page} className='btnnnn'  onClick={()=>{setPage(page+1)}}><ArrowForward/></button> */}
  </div>
  <div className='d-flex justify-content-center align-items-center' style={{gap:'8px',overflowX:'auto',marginTop:'15px'}}>
        {cattleListAddComment?.length?cattleListAddComment.map((item,index)=>{
          return <div className='itemFilterr' key={index}>
             
        <div className='d-flex' style={{gap:'7px'}}>
          
          <div className='d-flex align-items-center' style={{gap:'7px'}}><Sell color='success' fontSize='small'/>  {item?.earTagNumber?item?.earTagNumber:'---'}</div>
        </div>
        
      
      <div onClick={()=>handleDelete(item)} className='closebtn'>
          <Close fontSize='small'/>
      </div>
          </div>
        }):''}
  </div>
  {cattleListAddComment?.length?<div className='btnConfirmComment' style={{width:'100px',padding:'5px',margin:'10px auto',fontSize:'14px'}} onClick={openModallComment}>ایجاد یادداشت</div>:''}
  </div>
}

const PensFilt=()=>{
  const {currentAdmin}=useSelector(state=>state.p.admin)
  const {currentPens,tempPen}=useSelector(state=>state.pens)
  const dispatch=useDispatch()

        const getPens=async()=>{
          const data={
            "skip": -1,
            "take": -1,
            "fromDate": null,
            "toDate":null
          }
          const res=await apiService.getPens(data)
          dispatch(loginSuccessP(res.data.data))
           
      }
      useEffect(()=>{
        getPens()
      },[])
  return <div className='penFiltComCon d-flex justify-content-center '>
    <div onClick={()=>{dispatch(ToTempPen(''))}}  className={`penFiltCom ${tempPen===''?'active':''}`}>همه</div>
          {currentPens.map((item,index)=>{
            return <div onClick={()=>{dispatch(ToTempPen(item.id))}} key={index} className={`penFiltCom ${tempPen===item.id?'active':''}`}>{item.name}</div>
          })}
  </div>
}

const CommentsPage=()=>{
  const {currentAdmin}=useSelector(state=>state.p.admin)
  const {currentPens,tempPen}=useSelector(state=>state.pens)
  const [value, setValue] = useState('1');
 
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
    return <>
    
            
            
    <div className='wraping' style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'95%',direction:'rtl'}}>
    <div className={S.SingleDamTitleCon}>
        <img width={80} height={80} className={S.SingleDamimgTit} src={Note}/>
        <h2 >یادداشت های دام</h2>
        </div>
        <div className='wraping' style={{display:'flex',gap:'10px',flexWrap:'wrap',justifySelf:'end'}}>
        
        {/* <div title='افزودن یادداشت' onClick={openModallComment} className={S.EditBtnTableDam}>
                <RateReviewIcon/>
            </div> */}

        
        </div>
 
    </div>
    
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box>
          <TabList style={{direction:'rtl'}} onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="دام ها" value="1" />
            <Tab label="بهاربند ها" value="2" />
            <Tab label=" دامداری" value="3" />
          </TabList>
        </Box>
        <hr style={{width:'100%',marginTop:'-3px'}}/>
        <TabPanel value="1">
           <CattleLIFilter/>
           <CommentsListComp flag={'cattles'}/> </TabPanel>
        <TabPanel value="2">
          <PensFilt/>
          <CommentsListComp penId={tempPen} flag={'pens'}/>
        </TabPanel>
        <TabPanel value='3'>
            <CommentsListComp flag={'farm'} farmId={currentAdmin?.id}/>
        </TabPanel>
      </TabContext>
    </Box>
    </>
}

export default CommentsPage